/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SidebarService from 'cio/services/sidebar';
import { inject as service } from '@ember/service';
import { CONTENT_TARGET_ID } from 'cio/components/sidebar';
import { registerDestructor } from '@ember/destroyable';

interface Args {
  sidebarId: string;
  onClose: () => unknown;
}

export default class SidebarContent extends Component<Args> {
  @service sidebar!: SidebarService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    registerDestructor(this, () => {
      if (this.sidebar.isOpen && this.args.sidebarId === this.sidebar.activeSidebarId) {
        this.sidebar.close();
      }
    });
  }

  get sidebarPanelContent() {
    return document.querySelector(`#${CONTENT_TARGET_ID}`);
  }
}
